export default () => ({
  root: {
    flexGrow: 1,
  },
  column: {
    padding: 5,
  },
  title: {
    fontWeight: 'bold',
  },
  actionsBar: {
    marginBottom: 15,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  actionsBarBtn: {
    marginLeft: 5,
  },
  builderBody: {

  },
  previewBody: {
    maxWidth: '600px',
    background: 'white',
  },
  previewBodyContainer: {
    background: '#d2d2d2',
    display: 'flex',
    justifyContent: 'center',
    height: 'auto',
  },
  previewHeader: {
    background: '#F2F6FA',
    padding: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  previewContent: {
    marginLeft: 15,
    marginRight: 15,
  },
  previewContentBody: {
    fontFamily: 'Source Sans Pro',
    margin: '15px auto',
  },
  previewFooter: {
    marginBottom: 10,
    marginLeft: 15,
    marginRight: 15,
  },
  previewFooterText: {
    borderTop: '1px solid #C2D6E9',
    paddingTop: 15,
    fontStyle: 'normal',
    fontSize: 12,
    lineHeight: 1.4,
    color: '#767676',
  },
  footer: {

  },

  progress: {

  },
  progressBtn: {
    width: '15px',
    height: '15px',
    marginRight: '15px',
    color: 'white',
  },
  modelItem: {

  },
  modelItemFields: {
    borderBottom: 'solid 1px #efefef',
    padding: '10px 0',
  },
  inputItem: {
  },
  inputItemContent: {
    background: '#efefef',
    padding: 15,
    border: 'solid 1px #eaeaea',
    marginBottom: 20,
  },
  inputItemFormControl: {
    width: '100%',
  },
  inputItemButton: {
    marginTop: 15,
  },
  inputsContainer: {

  },
  leftIcon: {
    marginRight: 5,
  },
  rightIcon: {
    marginLeft: 5,
  },
  toolButton: {
    marginBottom: 15,
  },
  titleInput: {
    marginBottom: 15,
    width: '100%',
  },
  contextPreviewItem: {
    paddingLeft: '100px',
    paddingRight: '100px',
    margin: '5px auto',
  },
  contextPreviewItemEdit: {
    background: '#e6f3ff',
    border: 'solid 1px #a2d2ff',
    paddingTop: '5px',
    paddingBottom: '5px',
  },
  contextPreviewButton: {
    background: '#0255A3',
    boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '40px',
    color: 'white',
    letterSpacing: '0.424242px',
    fontSize: '24px',
    lineHeight: '30px',
    cursor: 'pointer',
    minWidth: '240px',
    maxWidth: '280px',
    textAlign: 'center',
    padding: '5px',
    margin: '15px auto',
  },
  contextPreviewText: {
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '20px',
    color: '#3C3C3C',
    whiteSpace: 'pre-line',
  },
  editModeActions: {
    position: 'relative',
    background: '#cae6ff',
    padding: '0 10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginRight: '-100px',
    marginLeft: '-100px',
    marginTop: '-5px',
  },
  editModeAction: {
    marginRight: 5,
    cursor: 'pointer',
    color: '#0255A3',
  },
  editModeActionsMetadata: {
    color: '#3C3C3C',
    fontFamily: 'monospace',
  },
  editModeMetadataType: {
    background: '#0255A3',
    padding: '5px',
    display: 'inline',
    color: 'white',
  },
  contextPreviewSpacing: {

  },
  contextPreviewLink: {
    cursor: 'pointer',
    color: '#4D88BE',
    fontSize: '16px',
  },
  contextPreviewModel: {
  },
  previewModelTable: {
    width: '100%',
    margin: 'auto',
    '& tr td:last-child': {
      textAlign: 'right',
    },
    '& tr': {
      marginBottom: '10px',
    },
  },
  previewModeTableKey: {
    color: '#3C3C3C;',
    fontSize: '16px',
    lineHeight: '16px',
    paddingBottom: '5px',
  },
  previewModeTableValue: {
    color: '#3C3C3C;',
    fontSize: '16px',
    lineHeight: '16px',
  },
  errorNotification: {
    '& > div': {
      background: '#ff4444',
    },
  },
  topLevelSelect: {
    width: '100%',
  },
  fab: {
    background: '#2196f3',
    color: '#ffffff',
    borderRadius: '100%',
    height: '64px',
    width: '64px',
    position: 'fixed',
    bottom: '50px',
    cursor: 'pointer',
    right: '50px',
    boxShadow: '0 5px 10px #aaa',
    display: 'none',
  },
  dialogInfoTitle: {
    margin: '0',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: 'solid 1px #efefef',
    padding: '15px 25px',
    display: 'flex',
    fontSize: '22px',
  },
  dialogSection: {
    marginBottom: '25px',
  },
  dialogSectionBody: {
    marginBottom: '10px',
  },
  dialogTitle: {
    fontSize: '20px',
    fontWeight: 'lighter',
  },
  errorMessages: {
    margin: '5px 0',
  },
  errorMessage: {
    margin: 0,
    color: 'red',
  },
  showFabButton: {
    width: '80PX',
    height: '80PX',
    borderRadius: '100%',
    position: 'fixed',
    bottom: '30px',
    right: '80px',
  },
});



// WEBPACK FOOTER //
// ./src/components/EmailTemplates/TemplateBuilderStyle.js